import { Layout, NavDrawer, Panel } from '@luminopia/react-toolbox/lib/layout'
import Navigation from '@luminopia/react-toolbox/lib/navigation'
import AppBar from 'core/components/AppBar'
import {ActivityLink} from 'core/components/link'
import NavigationItem, {ITheme as INavigationItemTheme} from 'core/components/NavigationItem'
import * as React from 'react'
import {RouteComponentProps} from 'react-router'
import * as routes from '../../routes'
import * as appBarTheme from './appBarTheme.css'
import * as classNames from './dashboard.css'

// TODO: @luminopia/react-toolbox type definition for NavDrawer is missing the base props,
// so we can't specify className on it. This works for now until that type def is fixed
const navDrawerTheme = {pinned: classNames.navDrawer, clipped: classNames.navDrawer}

interface IOwnProps extends RouteComponentProps<void> {}

interface IProps extends IOwnProps {}

class Dashboard extends React.PureComponent<IProps, {}> {
  public render() {
    const navigationItemTheme: INavigationItemTheme = {
      container: classNames.itemContainer,
      containerActive: classNames.itemContainerActive,
      iconContainer: classNames.itemIconContainer,
      labelContainer: classNames.itemLabelContainer,
      label: classNames.itemLabel,
    }

    return (
      <Layout>
        <AppBar theme={appBarTheme} />
        <NavDrawer pinned theme={navDrawerTheme}>
          <Navigation className={classNames.nav} type='vertical'>
          <p className={classNames.statusText}>Token Generator Tool | v1.2</p>
            <ActivityLink to={routes.subjectsListRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='people_outline'
                  label='View patients'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
            <ActivityLink to={routes.subjectCreateRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='add'
                  label='Add patient'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
            <ActivityLink to={routes.logoutRoute()}>
              {(active: boolean) => (
                <NavigationItem
                  icon='exit_to_app'
                  label='Log out'
                  active={active}
                  theme={navigationItemTheme}
                />
              )}
            </ActivityLink>
          </Navigation>
        </NavDrawer>
        <Panel className={classNames.panel}>
          <div className={classNames.contentContainer}>
            {this.props.children}
          </div>
        </Panel>
      </Layout>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/dashboard/dashboard.tsx